<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container style="text-align: center">
        <b-alert show variant="info" class="mt20" style="margin-bottom:0px" dismissible v-if="showPrompt">
            <div style="text-align: left;" v-html="promptMsg"></div>
        </b-alert>
        <b-row>
            <b-col style="margin-top:30px" lg="6" xl="6" sm="12" md="6">
                <b-carousel id="carousel-1" v-model="slide" :interval="3000" fade indicators label-indicators="sdfsdf"
                    background="#ababab" @sliding-start="onSlideStart" @sliding-end="onSlideEnd" img-width="1024"
                    img-height="720">
                    <b-carousel-slide v-if="picNews.length == 0" caption="国家自然基金共享航次计划"
                        img-src="../../statics/img-02.png"></b-carousel-slide>

                    <b-carousel-slide v-for="item in picNews" v-bind:key="item.newsId" style="pointer:handler"
                        :caption="item.title" :img-src="item.coverPhoto">
                        <template v-slot:img>
                            <img style="cursor:pointer;object-fit:cover;" class="d-block img-fluid w-100" width="1024"
                                height="480" :src="item.coverPhoto2" alt="image slot" @click="carouselClick(item)" />
                        </template>
                    </b-carousel-slide>
                </b-carousel>
            </b-col>

            <b-col style="margin-top:30px" lg="6" xl="6" sm="12" md="6">
                <b-tabs>
                    <template v-slot:tabs-end>
                        <div style="padding:1px 20px; background-color:#f1f1f1; color:#115CA5;">
                            <li class="nav-item align-self-center" style="font-size: 18px;">公告</li>
                        </div>
                        <b-button variant="light" class="nav-item align-self-center" @click="toNews3"
                            style="font-size:14px; color:#10477C;padding:0px">更多</b-button>
                    </template>
                </b-tabs>
                <b-list-group>
                    <b-list-group-item v-for="(item, index) in items" :key="index"
                        class="d-flex justify-content-between align-items-center"
                        style="font-size: 16px;min-height: 54px;padding: 10px;line-height: 25px;text-align:left;"
                        :href="'/detail?id=' + item.newsId" target="_blank">
                        <span>
                            {{ item.title }}
                            <!-- <b-badge variant="primary">Primary</b-badge> -->
                            <b-badge variant="danger" style="margin-right: 5px;" v-if="item.isNew">New</b-badge>
                        </span>
                        {{ item.dateFormate }}
                    </b-list-group-item>
                </b-list-group>

                <!--- 新闻 ---->
                <b-tabs>
                    <template v-slot:tabs-end>
                        <div style="padding:1px 20px; background-color:#f1f1f1; color:#115CA5;margin-top:10px;">
                            <li class="nav-item align-self-center" style="font-size: 18px;">新闻</li>
                        </div>
                        <b-button variant="light" class="nav-item align-self-center" @click="toNews3"
                            style="font-size:14px; color:#10477C;padding:0px">更多</b-button>
                    </template>
                </b-tabs>
                <b-list-group>
                    <b-list-group-item v-for="(item, index) in items2" :key="index"
                        class="d-flex justify-content-between align-items-center"
                        style="font-size: 16px;min-height: 54px;padding: 10px;line-height: 25px;text-align:left;"
                        :href="'/detail?id=' + item.newsId" target="_blank">
                        <span>
                            {{ item.title }}
                            <!-- <b-badge variant="primary">Primary</b-badge> -->
                            <b-badge variant="danger" style="margin-right: 5px;" v-if="item.isNew">New</b-badge>
                        </span>
                        {{ item.dateFormate }}
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
        <b-row class="d-flex justify-content-between mt20">

            <!-- <b-col xs="12" sm="12" md="3" lg="2" xl="2" class="item-card">
                <div class="project-card align-content-center" @click="tosvpChiefTraining" style="background: #1C908A;">
                    <i class="iconfont inline" style="font-size: 40px;">&#xe61b;</i>
                    <p style="font-size: 20px;">首席培训航次申请</p>
                </div>
            </b-col> -->

            <b-col xs="12" sm="12" md="3" lg="3" xl="3" class="item-card">
                <div class="project-card align-content-center" @click="toOption" style="background: #60afdd;">
                    <i class="iconfont inline" style="font-size: 60px;">&#xe601;</i>
                    <p style="font-size: 20px;">搭载需求申请</p>
                </div>
            </b-col>

            <b-col xs="12" sm="12" md="3" lg="3" xl="3" class="item-card">
                <div class="project-card color-sb align-content-center" @click="toChiefScientistExplain2"
                    style="background: #5389d7;">
                    <!--5389D7-->
                    <i class="iconfont inline" style="font-size: 40px;">&#xe61b;</i>
                    <p style="font-size: 20px;padding-left:10px;padding-right:10px">重大科学技术问题研究科学考察项目需求建议</p>
                </div>
            </b-col>

            <b-col xs="12" sm="12" md="3" lg="3" xl="3" class="item-card">
                <div class="project-card color-sb align-content-center" @click="toChiefScientistExplain"
                    style="background: #5389d7;">
                    <!--5389D7-->
                    <i class="iconfont inline" style="font-size: 60px;">&#xe61b;</i>
                    <p style="font-size: 20px;">首席科学家申请简表</p>
                </div>
            </b-col>

            <b-col xs="12" sm="12" md="3" lg="3" xl="3" class="item-card">
                <div class="project-card color-sb align-content-center" @click="toChiefScientistOpinion"
                    style="background: #777dcd;">
                    <i class="iconfont inline" style="font-size: 60px;">&#xe67e;</i>
                    <p style="font-size: 20px;">首席科学家预评估意见表</p>
                </div>
            </b-col>
        </b-row>
        <link-component></link-component>
    </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '../../api/judge';
import { urls } from '@/api/urls';
import { requestIndexConfig } from '@/api/SvpConfig';
import { formatDate } from '@/utils/date';

export default {
    components: { LinkComponent },
    name: 'Home',
    props: {
        msg: String,
    },
    data() {
        return {
            showPrompt: false,
            items: [],
            items2: [],
            slide: 0,
            sliding: null,
            promptMsg: '',
            picNews: [],
        };
    },
    mounted() {
        this.requestNotice();
        this.requestNotice2();
        this.requestPicNews();
        requestIndexConfig()
            .then((resp) => {
                this.promptMsg = resp.content;
                this.showPrompt = !resp.expired;
            })
            .catch((e) => {
            });
    },
    methods: {
        carouselClick(item) {
            // this.$router.push({ name: 'detail', query: { id: item.newsId } });
            window.open('/detail?id=' + item.newsId);
        },
        toNews3() {
            this.$router.push({ name: 'news', query: { type: 3 } });
        },
        //请求公告
        requestNotice() {
            axiosServer({
                url: urls.notice,
                params: { page: 1, pageSize: 3 },
            }).then((resp) => {
                resp.data.page.list.forEach((item) => {
                    item.dateFormate = formatDate(new Date(item.createTime.replace(/-/g, '/')), 'MM/dd');
                    let timePeriod = new Date().getTime() - new Date(item.createTime.replace(/-/g, '/'));
                    let oneMonth = 30 * 24 * 60 * 60 * 1000;
                    item.isNew = timePeriod < oneMonth;
                });
                this.items = resp.data.page.list;
            });
        },

        //请求新闻
        requestNotice2() {
            axiosServer({
                url: urls.news,
                params: { page: 1, pageSize: 3 },
            }).then((resp) => {
                resp.data.page.list.forEach((item) => {
                    item.dateFormate = formatDate(new Date(item.createTime.replace(/-/g, '/')), 'MM/dd');
                    let timePeriod = new Date().getTime() - new Date(item.createTime.replace(/-/g, '/'));
                    let oneMonth = 30 * 24 * 60 * 60 * 1000;
                    item.isNew = timePeriod < oneMonth;
                });
                this.items2 = resp.data.page.list;
            });
        },

        requestPicNews() {
            axiosServer({
                url: urls.carousel,
                params: { page: 1, pageSize: 7 },
            }).then((resp) => {
                this.picNews = resp.data.page.list;

                this.picNews.forEach((item) => {
                    item.coverPhoto2 = (process.env.NODE_ENV == 'development' ? urls.picUrl : urls.picUrl2) + item.coverPhoto;
                });
            });
        },
        tosvpChiefTraining() {
            this.$router.push({ name: 'svpChiefTraining' });
        },
        toOption() {
            this.$router.push({ name: 'options' });
        },
        toChiefScientistExplain() {
            this.$router.push({ name: 'ChiefScientistExplain' });
        },

        toChiefScientistExplain2() {
            this.$router.push({ name: 'scientificOrientation' });
        },

        toChiefScientistOpinion() {
            this.$router.push({ name: 'ChiefScientistOpinion' });
        },

        onSlideStart(slide) {
            this.sliding = true;
        },
        onSlideEnd(slide) {
            this.sliding = false;
        },
    },
};
</script>
<style>
/*轮播图的样式修改*/
.carousel-control-prev-icon {
    padding: 20px;
}

.carousel-control-next-icon {
    padding: 20px;
}

.carousel-caption {
    background-color: rgba(0, 0, 0, 0.6);
    width: 100%;
    margin-left: 0px;
    left: 0px;
    bottom: 0px;
    padding-top: 25px;
    padding-bottom: 5px;
    text-align: center;
    padding-left: 10px;
    font-size: 14px !important;
}

.carousel-caption h3 {
    font-size: 16px;
    font-weight: normal;
}

.carousel-indicators {
    padding-bottom: 15px;
}
</style>

<style scoped>
.link-title {
    color: #303133;
    padding-top: 10px;
    font-weight: 600;
    font-size: 16px;
    margin-top: 20px;
}

.link-itemP {}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
}

p {
    margin: 0;
}

.card {
    border: none;
}

.list-group-item {
    border: none;
    border-bottom: 1px solid #ebebeb;
    line-height: 1rem;
    font-size: 13px;
}

.tabs {
    padding-right: 10px;
}

.tabs /deep/ .nav-tabs {
    display: flex;
    justify-content: space-between;
}

.item-card {}

.project-card {
    padding: 10px 0;
    border-radius: 8px;
    color: #fff;
    margin-top: 10px;
    cursor: pointer;
}
</style>
